import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import SpinLoader from "../components/spin-loader";
import { hideOverlay } from "../utils/utils";
import { useNavigate } from 'react-router-dom';
import MoodboardComponent from '../components/moodboard/moodboard-comp';

const Moodboard = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const createLbl = i18n.exists("pages.create") ? t('pages.create') : "Създай";
    let [isSpinning, setIsSpinning] = useState(true);


    return (
        <div className="moodboard-page">
            <h1 className="page-h1">{i18n.exists("pages.moodBoard") ? t('pages.moodBoard') : "MoodBoard"}</h1>
            <MoodboardComponent />
        </div>
    )
}

export default Moodboard;